<template>
  <div style="display: flex; align-items: center;">
    <div style="flex: 0 0 20px;">
      <strong>{{ object.quantity === 0 ? $t('share.no') : object.quantity }}</strong>
    </div>
    <span
      :style="
        `background: ${spanBg}; border-radius: 8px; color: white; padding: 8px 8px; margin: auto 4px; font-weight: 700;`
      "
    >
      {{ name }}
    </span>
    <span
      v-html="
        object.quantity === 0
          ? $t('leadWeekly.intro.noLeads')
          : $t('leadWeekly.intro.leads', {
              value: numberFormat({
                number: object.amount,
                style: 'currency',
                currency: object.currency,
                notation: 'compact',
              }),
            })
      "
    ></span>
  </div>
</template>

<script>
import { numberFormat } from '@/utils/formatters.util'

export default {
  name: 'LpeReportLeadRowCount',
  props: {
    object: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    spanBg: {
      type: String,
      required: false,
      default: '#166ED6',
    },
  },
  data() {
    return {
      numberFormat,
    }
  },
}
</script>
